export default "__VITE_ASSET__58d6970d__"